import React from "react";
import { connect } from "react-redux";
import { History } from "history";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Table from "components/Table";
import FieldChooser from "components/FieldChooser";
import TopButtons from "components/TopButtons";
import { IMeta, IDelivery, ICommonState } from "models/.";
import { URLS } from "constants/urlConstants";
import { columns } from "./columns";
import DeliveryActions from "./actions";
import DeliverySearch from "./partials/DeliverySearch";
import { markAsRead, markAsUnread } from "../app/actions";
import { downloadDocuments } from "helpers/download";
import { getSelectedData } from "helpers/common";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps {
  getDeliveries: (meta?: IMeta) => void;
  deliveries: IDelivery[];
  meta: IMeta;
  history: History;
  getExportData: () => void;
  roleIds: any[];
}

interface IState extends ICommonState {
  selectedData: any;
}

class Deliveries extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: "",
      showFieldChooser: false,
      columnsCopy: [],
      checkedRows: {},
      selectedData: [],
    };
  }

  public handleSelect = (selectedOption) => {
    const { checkedRows, selectedData } = this.state;
    const { value } = selectedOption;
    const ids = _(checkedRows).keys().map(_.toNumber).value();

    value === "gelezen" && markAsRead(ids, "Levering");
    value === "ongelezen" && markAsUnread(ids, "Levering");
    if (value === "pdf") {
      const documentIds = _.compact(_.map(selectedData, "documentId"));
      downloadDocuments(documentIds, "DELIVERIES");
      markAsRead(ids, "Levering");
    }
  };

  public onRowClick = (rowData) => {
    this.props.history.push(
      `${URLS.DELIVERIES_URL}/${rowData.Id}?kooptype=${rowData.RoleId}`
    );

    if (!_.get(rowData, "Read", true)) {
      markAsRead([rowData.Id], "Levering");
    }
  };

  public handleFieldChooser = () => {
    this.setState((prevState) => ({
      showFieldChooser: !prevState.showFieldChooser,
    }));
  };

  public handleFieldsChange = (data) => {
    this.setState({ columnsCopy: data });
  };

  private onRowSelect = (checkedRows) => {
    this.setState({
      checkedRows,
      selectedData: getSelectedData(
        this.props.deliveries,
        checkedRows,
        this.state.selectedData
      ),
    });
  };

  public render() {
    const { deliveries, meta, getDeliveries, roleIds } = this.props;
    const { showFieldChooser, columnsCopy, selectedOption, checkedRows } =
      this.state;

    return (
      <div id="orders-page">
        <FormattedMessage id="DELIVERIES_HEADER" tagName="h1" />
        <DeliverySearch
          meta={meta}
          onSearch={getDeliveries}
          roleIds={roleIds}
        />
        <TopButtons
          switchUnread={meta.unread}
          handleFieldChooser={this.handleFieldChooser}
          handleSelect={this.handleSelect}
          toggleUnread={() =>
            getDeliveries({
              ...meta,
              unread: !meta.unread,
              currentPage: 0,
            })
          }
          selectedOption={selectedOption}
          entityName="deliveries"
        />
        <Table
          columns={columnsCopy}
          dataSource={deliveries}
          onRowClick={this.onRowClick}
          meta={meta}
          onQueryChange={getDeliveries}
          onRowSelect={this.onRowSelect}
          checkedRows={checkedRows}
          pageName={CUSTOM_SETTINGS.deliveries}
        />
        <FieldChooser
          name="leveringen"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={columns}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    deliveries: state.deliveries.items,
    meta: state.deliveries.meta,
    roleIds: state.app.roleIds,
  }),
  {
    getDeliveries: DeliveryActions.getDeliveries,
  }
)(Deliveries);
